var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel panel-flat"},[_c('div',{staticClass:"panel-heading"},[_c('h4',[_c('i',{staticClass:"fa fa-home"}),_vm._v(" "+_vm._s(_vm.transEdit('welcome'))+" "+_vm._s(_vm.part.username)+"!")])]),_vm._v(" "),_c('div',{staticClass:"panel-body"})])
}
var staticRenderFns = []

export { render, staticRenderFns }